/* Moved out of snippets/ola-accessibility.liquid (speed pass, 25.10.2026): the same code, now a deferred file instead of inline in every page. */
  (function () {
    var root = document.querySelector('[data-ola-a11y]');
    if (!root) return;

    var panel = root.querySelector('[data-a11y-panel]');
    var opener = root.querySelector('[data-a11y-open]');
    /* FROM THE DOCUMENT, NOT FROM THE WIDGET, and this cost the whole panel.

       The ruler and the mask were moved out to body level so a filter on the widget could
       not shrink them (the comment at the top of this file explains why). These four
       lookups were left behind, still searching inside the 52px widget, so all four were
       null. render() then threw on the first `ruler.hidden`, every single time it ran, and
       everything after that line never happened: stopping video, muting, the alt text, the
       keyboard jumps, the read-aloud and the two hints. The attributes above the throw
       still landed, so the panel looked like it worked, which is why it went unnoticed. */
    var ruler = document.querySelector('[data-a11y-ruler]');
    var mask = document.querySelector('[data-a11y-mask]');
    var maskTop = document.querySelector('.ola-a11y__mask-top');
    var maskBottom = document.querySelector('.ola-a11y__mask-bottom');
    var fontValue = root.querySelector('[data-a11y-font-value]');
    var html = document.documentElement;

    var KEY = 'olaA11y';
    var FONT_MIN = 1;
    var FONT_MAX = 1.6;
    var FONT_STEP = 0.1;

    /* Every switch the shopper can throw, in one object, so saving and restoring is one
       read and one write and a new option cannot be forgotten in one of the two. */
    var state = { font: 1, contrast: '', align: '', profile: '', colors: {}, toggles: {} };

    function load() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return;
        var saved = JSON.parse(raw);
        if (saved && typeof saved === 'object') {
          state.font = Number(saved.font) || 1;
          state.contrast = String(saved.contrast || '');
          state.align = String(saved.align || '');
          state.profile = String(saved.profile || '');
          state.colors = saved.colors && typeof saved.colors === 'object' ? saved.colors : {};
          state.toggles = saved.toggles && typeof saved.toggles === 'object' ? saved.toggles : {};
        }
      } catch (e) {}
    }
    function save() {
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }

    /* Text size, measured then multiplied.
       Every element's own rendered size is read once and remembered, and from then on the
       element is set to that remembered size times the factor. Remembering the ORIGINAL
       rather than the current size is what makes this idempotent: pressing bigger five
       times and then reset lands exactly where the theme had it, with no drift.
       The widget itself is excluded, or its own controls grow along with the page and the
       panel stops fitting on screen at the moment she needs it most. */
    /* A text node of its own, rather than only element children. */
    function hasOwnText(el) {
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim()) return true;
      }
      return false;
    }

    function setFontScale(f) {
      var nodes = document.body.querySelectorAll('*');
      var i, el;

      /* Two passes, and the order is the whole trick. Measuring and writing in one loop
         reads a child AFTER its parent has already been enlarged, so a child sized in em
         or % measures bigger than it really was and that inflated number gets remembered
         as its original. A 14px link came out at 27px instead of 16.8px. Measure the whole
         page first, write afterwards. */
      /* Reads first, writes after, and never interleaved. getComputedStyle forces the
         browser to bring layout up to date, and setAttribute invalidates it again, so
         measuring and stamping in the same loop makes the browser recalculate the whole
         page once per element. On this shop that was thousands of forced reflows and the
         tab stopped responding on the heaviest profile. Collecting the measurements and
         then writing them costs one recalculation instead of one per element.
         Only elements that actually hold words are measured: a wrapper with no text of
         its own inherits from its children's own sizes and changes nothing on screen. */
      var measured = [];
      for (i = 0; i < nodes.length; i++) {
        el = nodes[i];
        if (root.contains(el)) continue;
        if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
        if (el.getAttribute('data-a11y-fs') !== null) continue;
        if (!hasOwnText(el)) continue;
        var cs = parseFloat(window.getComputedStyle(el).fontSize);
        if (cs) measured.push([el, cs]);
      }
      for (i = 0; i < measured.length; i++) {
        measured[i][0].setAttribute('data-a11y-fs', String(measured[i][1]));
      }

      for (i = 0; i < nodes.length; i++) {
        el = nodes[i];
        var orig = el.getAttribute('data-a11y-fs');
        if (orig === null) continue;
        if (f === 1) el.style.removeProperty('font-size');
        else el.style.setProperty('font-size', (parseFloat(orig) * f).toFixed(2) + 'px', 'important');
      }

      if (f === 1) {
        var done = document.querySelectorAll('[data-a11y-fs]');
        for (var j = 0; j < done.length; j++) done[j].removeAttribute('data-a11y-fs');
      }
    }

    /* The shop re-renders: the cart drawer, quick add, the advisor's own answers. Anything
       that arrives after she chose a size has never been measured, so it would appear at
       the theme's size in the middle of an enlarged page. Cheap to catch, and only watched
       while a scale is actually in force. */
    var observer = null;
    function watchNewContent() {
      if (observer || !window.MutationObserver) return;
      var pending = null;
      observer = new MutationObserver(function () {
        if (pending || selfWriting) return;
        pending = setTimeout(function () { pending = null; if (state.font !== 1) setFontScale(state.font); }, 250);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    function unwatchNewContent() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    /* Applying a setting rewrites a great many elements, and this file runs two
       MutationObservers that exist to catch content the shop renders later. Left alone,
       they see our own writes and call us again: one control turned a single press into
       176 writes to storage. The fix is not to block applying, which would also block the
       shopper's next press; it is to make the observers ignore the changes we made
       ourselves. Anything that arrives while we are writing is picked up by the timed
       passes that already run. */
    var selfWriting = false;

    function apply() {
      selfWriting = true;
      /* Long enough to outlast the observers' own debounce, so a heavy apply cannot end
         up being observed halfway through and started again. */
      try { applyNow(); } finally { setTimeout(function () { selfWriting = false; }, 800); }
    }

    function applyNow() {
      setFontScale(state.font);
      if (state.font !== 1) { html.setAttribute('data-a11y-font', '1'); watchNewContent(); }
      else { html.removeAttribute('data-a11y-font'); unwatchNewContent(); }
      if (fontValue) fontValue.textContent = Math.round(state.font * 100) + '%';


      if (state.contrast) html.setAttribute('data-a11y-contrast', state.contrast);
      else html.removeAttribute('data-a11y-contrast');

      if (state.align) html.setAttribute('data-a11y-align', state.align);
      else html.removeAttribute('data-a11y-align');

      /* The three chosen colours. Each is a variable plus a marker attribute, so the CSS
         can stay one rule per target rather than one per colour. */
      [['text', 'ctext'], ['title', 'ctitle'], ['bg', 'cbg']].forEach(function (pair) {
        var chosen = state.colors[pair[0]];
        if (chosen) {
          html.setAttribute('data-a11y-' + pair[1], '1');
          html.style.setProperty('--a11y-' + pair[1], chosen);
        } else {
          html.removeAttribute('data-a11y-' + pair[1]);
          html.style.removeProperty('--a11y-' + pair[1]);
        }
      });
      root.querySelectorAll('[data-a11y-paint]').forEach(function (b) {
        var slot = b.getAttribute('data-a11y-paint');
        var val = b.getAttribute('data-a11y-value');
        var current = state.colors[slot] || '';
        b.setAttribute('aria-pressed', val === current ? 'true' : 'false');
      });

      Object.keys(state.toggles).forEach(function (name) {
        if (state.toggles[name]) html.setAttribute('data-a11y-' + name, '1');
        else html.removeAttribute('data-a11y-' + name);
      });

      /* The buttons must report what they actually did, or a screen reader user cannot
         tell an active setting from an inactive one. */
      root.querySelectorAll('[data-a11y-contrast]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-a11y-contrast') === state.contrast ? 'true' : 'false');
      });
      root.querySelectorAll('[data-a11y-toggle]').forEach(function (b) {
        var n = b.getAttribute('data-a11y-toggle');
        b.setAttribute('aria-pressed', state.toggles[n] ? 'true' : 'false');
      });
      root.querySelectorAll('[data-a11y-align]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-a11y-align') === state.align ? 'true' : 'false');
      });
      root.querySelectorAll('[data-a11y-profile]').forEach(function (b) {
        var on = b.getAttribute('data-a11y-profile') === state.profile;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (b.getAttribute('data-on') === null) b.setAttribute('data-on', on ? '1' : '0');
      });

      if (ruler) ruler.hidden = !state.toggles.ruler;
      if (mask) mask.hidden = !state.toggles.mask;
      if (state.toggles.mask || state.toggles.ruler) bindPointer();
      if (state.toggles.alt) showAlts(); else hideAlts();
      if (state.toggles.still) stopMedia(); else resumeMedia();
      if (state.toggles.mute) muteMedia();
      if (state.toggles.kbnav) bindJumpKeys(); else unbindJumpKeys();
      var hint = root.querySelector('[data-a11y-kbhint]');
      if (hint) hint.hidden = !state.toggles.kbnav;
      var shint = root.querySelector('[data-a11y-speakhint]');
      if (shint) shint.hidden = !state.toggles.speak;
      if (state.toggles.speak) bindSpeak(); else unbindSpeak();
    }

    /* Alt text, surfaced as visible text. Written once and reused, so toggling it twice
       does not stack duplicates under every photo. */
    function showAlts() {
      document.querySelectorAll('img[alt]:not([data-a11y-alt-done])').forEach(function (img) {
        var text = (img.getAttribute('alt') || '').trim();
        if (!text) return;
        var note = document.createElement('span');
        note.className = 'ola-a11y-alt';
        note.setAttribute('data-a11y-alt-note', '1');
        note.textContent = 'תיאור התמונה: ' + text;
        if (img.parentNode) img.parentNode.insertBefore(note, img.nextSibling);
        img.setAttribute('data-a11y-alt-done', '1');
      });
    }
    function hideAlts() {
      document.querySelectorAll('[data-a11y-alt-note]').forEach(function (n) { n.remove(); });
      document.querySelectorAll('[data-a11y-alt-done]').forEach(function (i) { i.removeAttribute('data-a11y-alt-done'); });
    }

    /* ── Read aloud ──────────────────────────────────────────────────────────
       Tap a paragraph, hear it. speechSynthesis is in every current browser and needs no
       key and no service, and Hebrew voices are installed on iOS, macOS, Android and
       Windows. Deliberately click driven rather than reading the whole page: a page that
       starts talking on load is the thing people switch off first. */
    var speakBound = false;
    var speakingEl = null;

    function stopSpeaking() {
      try { window.speechSynthesis.cancel(); } catch (e) {}
      if (speakingEl) speakingEl.classList.remove('ola-a11y-speaking');
      speakingEl = null;
    }

    function onSpeakClick(e) {
      if (!window.speechSynthesis) return;
      var el = e.target && e.target.closest ? e.target.closest('p, h1, h2, h3, h4, li, dd, figcaption, blockquote') : null;
      if (!el || root.contains(el)) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      // Tapping the paragraph that is already speaking stops it, which is what people try.
      if (speakingEl === el) { stopSpeaking(); return; }
      stopSpeaking();
      var u = new SpeechSynthesisUtterance(text.slice(0, 1200));
      u.lang = document.documentElement.lang || 'he-IL';
      u.rate = 0.95;
      u.onend = function () { stopSpeaking(); };
      speakingEl = el;
      el.classList.add('ola-a11y-speaking');
      try { window.speechSynthesis.speak(u); } catch (err) { stopSpeaking(); }
    }

    function bindSpeak() {
      if (speakBound || !window.speechSynthesis) return;
      document.addEventListener('click', onSpeakClick, true);
      speakBound = true;
    }
    function unbindSpeak() {
      if (!speakBound) return;
      document.removeEventListener('click', onSpeakClick, true);
      speakBound = false;
      stopSpeaking();
    }

    /* ── Profiles ────────────────────────────────────────────────────────────
       Every Israeli widget offers these, and the reason is good: someone who needs four
       adjustments should not have to find four buttons. A profile is only a named set of
       the switches that already exist, so nothing here can do something the individual
       controls cannot, and turning the profile off returns exactly what it turned on. */
    var PROFILES = {
      lowvision: { font: 1.4, toggles: { links: true, focus: true, cursor: true, headings: true }, contrast: 'high' },
      adhd:      { toggles: { still: true, mask: true, hideimg: true, focus: true } },
      dyslexia:  { toggles: { dyslexic: true, spacing: true, lineheight: true, wordspacing: true, links: true } },
      senior:    { font: 1.3, toggles: { readable: true, links: true, cursor: true, lineheight: true, still: true } }
    };

    function applyProfile(name) {
      // Off, or a different one: clear everything first so two profiles cannot stack.
      Object.keys(state.toggles).forEach(function (n) { html.removeAttribute('data-a11y-' + n); });
      html.removeAttribute('data-a11y-align');
      state.toggles = {};
      state.contrast = '';
      state.font = 1;
      state.colors = {};
      ['ctext', 'ctitle', 'cbg'].forEach(function (n) {
        html.removeAttribute('data-a11y-' + n);
        html.style.removeProperty('--a11y-' + n);
      });
      if (!name) { state.profile = ''; return; }
      var p = PROFILES[name];
      if (!p) return;
      state.profile = name;
      if (p.font) state.font = p.font;
      if (p.contrast) state.contrast = p.contrast;
      Object.keys(p.toggles).forEach(function (k) { state.toggles[k] = true; });
    }

    /* Sound, silenced at the element rather than at the volume control, so a video that
       starts later is silenced too. Separate from "stop animations": someone who needs
       quiet does not necessarily need the page to stop moving. */
    function muteMedia() {
      document.querySelectorAll('video, audio').forEach(function (m) {
        try { m.muted = true; m.volume = 0; } catch (e) {}
      });
    }

    /* Keyboard navigation, the Israeli convention: H for headings, B for buttons and
       links, G for images, F for forms, M for menus. Equality's own implementation paints
       a border on the element and leaves focus where it was, so a screen reader follows
       nothing and the mode is decorative. This moves REAL focus, which is the entire
       point: the browser announces the element, and Enter then activates it. */
    var JUMP = {
      72: { name: 'headings', sel: 'h1, h2, h3, h4, h5, h6' },
      66: { name: 'buttons', sel: 'a[href], button:not([disabled])' },
      71: { name: 'images', sel: 'img' },
      70: { name: 'forms', sel: 'input, select, textarea' },
      77: { name: 'menus', sel: 'nav, [role="navigation"], ul.rh-header__nav' }
    };
    var jumpAt = {};

    function onJumpKey(e) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      var tag = (e.target && e.target.tagName) || '';
      // Never steal a letter from someone typing.
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (e.target && e.target.isContentEditable)) return;
      var spec = JUMP[e.which || e.keyCode];
      if (!spec) return;
      var list = [];
      document.body.querySelectorAll(spec.sel).forEach(function (el) {
        if (root.contains(el)) return;
        if (!el.offsetParent && el.tagName !== 'BODY') return;
        list.push(el);
      });
      if (!list.length) return;
      e.preventDefault();
      var i = jumpAt[spec.name] === undefined ? -1 : jumpAt[spec.name];
      i = (i + (e.shiftKey ? -1 : 1) + list.length) % list.length;
      jumpAt[spec.name] = i;
      var el = list[i];
      if (!el.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) {
        el.setAttribute('tabindex', '-1');
      }
      try { el.focus(); } catch (err) {}
      el.scrollIntoView({ block: 'center' });
    }

    var jumpBound = false;
    function bindJumpKeys() {
      if (jumpBound) return;
      document.addEventListener('keydown', onJumpKey);
      jumpBound = true;
    }
    function unbindJumpKeys() {
      if (!jumpBound) return;
      document.removeEventListener('keydown', onJumpKey);
      jumpBound = false;
      jumpAt = {};
    }

    /* "Stop animations" has to reach video too. CSS cannot pause a video element.

       It also has to be undoable. The first version took the autoplay attribute off and
       put controls on, and nothing ever put either back, so switching the toggle off left
       the page with a row of paused reels wearing a control bar they were never designed
       to have. What this changed is written on the element, so resumeMedia() can put back
       exactly what it found and leave a video that always had controls alone. */
    function stopMedia() {
      document.querySelectorAll('video').forEach(function (v) {
        try {
          if (!v.dataset.a11yStilled) {
            v.dataset.a11yStilled = (v.hasAttribute('autoplay') ? 'a' : '') + (v.hasAttribute('controls') ? 'c' : '') || '-';
          }
          v.pause();
          v.removeAttribute('autoplay');
          v.setAttribute('controls', 'controls');
        } catch (e) {}
      });
    }

    /* Giving the page back. The reels restart themselves once the attribute is off, so
       this only has to undo what stopMedia did to the markup. */
    function resumeMedia() {
      document.querySelectorAll('video[data-a11y-stilled]').forEach(function (v) {
        try {
          var had = v.dataset.a11yStilled;
          if (had.indexOf('c') === -1) v.removeAttribute('controls');
          if (had.indexOf('a') !== -1) v.setAttribute('autoplay', 'autoplay');
          delete v.dataset.a11yStilled;
        } catch (e) {}
      });
    }

    var pointerBound = false;
    function bindPointer() {
      if (pointerBound) return;
      pointerBound = true;
      var move = function (e) {
        var y = e.clientY == null ? 0 : e.clientY;
        if (state.toggles.ruler && ruler) ruler.style.top = Math.max(0, y - 21) + 'px';
        if (state.toggles.mask && maskTop && maskBottom) {
          maskTop.style.height = Math.max(0, y - 70) + 'px';
          maskBottom.style.top = (y + 70) + 'px';
          maskBottom.style.bottom = '0';
        }
      };
      document.addEventListener('mousemove', move, { passive: true });
      document.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) move(e.touches[0]);
      }, { passive: true });
    }

    /* ── Opening and closing, with the focus handled properly ───────────────── */
    var lastFocus = null;

    function openPanel() {
      lastFocus = document.activeElement;
      panel.hidden = false;
      /* The button comes out of its dock while its own panel is open, so the two read as
         one object rather than a panel floating beside a sliver. */
      root.setAttribute('data-open', '1');
      /* The button is pushed up the screen to clear whatever else lives in that corner, and
         the panel opens upward from it, so on a phone the two together can run off the top.
         The height is fixed to what is actually above the button, and the panel scrolls
         inside that. A menu whose first option is off screen is a menu she cannot use. */
      var room = Math.round(opener.getBoundingClientRect().top - 24);
      panel.style.maxHeight = Math.max(220, Math.min(560, room)) + 'px';
      opener.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('button, a, [tabindex]');
      if (first) setTimeout(function () { try { first.focus(); } catch (e) {} }, 40);
    }
    function closePanel() {
      panel.hidden = true;
      root.removeAttribute('data-open');
      opener.setAttribute('aria-expanded', 'false');
      /* Back where she was. Dropping focus to the top of the document would make her
         walk the whole shop again to reach this button, which is the exact problem this
         widget exists to solve. */
      try { (lastFocus && lastFocus.focus) ? lastFocus.focus() : opener.focus(); } catch (e) {}
    }

    opener.addEventListener('click', function () {
      if (panel.hidden) openPanel(); else closePanel();
    });
    root.querySelector('[data-a11y-close]').addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { closePanel(); return; }
      /* A dialog that says aria-modal must actually hold the keyboard, or the promise
         it makes to a screen reader is false. */
      if (e.key !== 'Tab' || panel.hidden) return;
      var items = panel.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (!root.contains(e.target)) closePanel();
    });

    /* ── The controls ───────────────────────────────────────────────────────── */
    /* These two live here, with the other bindings, and the placement is the bug that
       taught it: they were once inside apply(), so every single adjustment added another
       click listener to every profile and alignment button. One press then ran the handler
       four times, then ten, then more, and a profile switched itself straight back off.
       Nothing binds an event inside a function that runs more than once. */
    root.querySelectorAll('[data-a11y-profile]').forEach(function (b) {
      b.addEventListener('click', function () {
        /* On or off is recorded on the button, written here and read here and nowhere
           else, so it cannot disagree with a value that apply() also writes. */
        var name = b.getAttribute('data-a11y-profile');
        var wasOn = b.getAttribute('data-on') === '1';
        root.querySelectorAll('[data-a11y-profile]').forEach(function (x) { x.setAttribute('data-on', '0'); });
        if (!wasOn) b.setAttribute('data-on', '1');
        applyProfile(wasOn ? '' : name);
        apply(); save();
      });
    });

    root.querySelectorAll('[data-a11y-paint]').forEach(function (b) {
      b.addEventListener('click', function () {
        var slot = b.getAttribute('data-a11y-paint');
        var val = b.getAttribute('data-a11y-value') || '';
        // Tapping the colour already chosen clears it, which is what people try first.
        state.colors[slot] = state.colors[slot] === val ? '' : val;
        state.profile = '';
        apply(); save();
      });
    });

    root.querySelectorAll('[data-a11y-align]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-a11y-align');
        state.align = state.align === v ? '' : v;
        apply(); save();
      });
    });

    root.querySelectorAll('[data-a11y-font]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-a11y-font') === 'up' ? 1 : -1;
        // Tenths, as whole numbers, for the same reason as the zoom control above.
        var ft = Math.round(Number(state.font) * 10);
        if (!ft || ft < 10) ft = 10;
        state.font = Math.min(FONT_MAX * 10, Math.max(FONT_MIN * 10, ft + dir)) / 10;
        apply(); save();
      });
    });

    root.querySelectorAll('[data-a11y-contrast]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-a11y-contrast');
        // The colour modes are mutually exclusive: two of them at once is unreadable.
        state.contrast = state.contrast === v ? '' : v;
        apply(); save();
      });
    });

    root.querySelectorAll('[data-a11y-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-a11y-toggle');
        state.toggles[n] = !state.toggles[n];
        // Once she changes one switch by hand, the profile no longer names what is on.
        state.profile = '';
        root.querySelectorAll('[data-a11y-profile]').forEach(function (x) { x.setAttribute('data-on', '0'); });
        if (n === 'readable' && state.toggles[n]) state.toggles.dyslexic = false;
        if (n === 'dyslexic' && state.toggles[n]) state.toggles.readable = false;
        if (!state.toggles[n]) html.removeAttribute('data-a11y-' + n);
        apply(); save();
      });
    });

    root.querySelector('[data-a11y-reset]').addEventListener('click', function () {
      Object.keys(state.toggles).forEach(function (n) { html.removeAttribute('data-a11y-' + n); });
      html.removeAttribute('data-a11y-align');
      ['ctext', 'ctitle', 'cbg'].forEach(function (n) {
        html.removeAttribute('data-a11y-' + n);
        html.style.removeProperty('--a11y-' + n);
      });
      root.querySelectorAll('[data-a11y-profile]').forEach(function (x) { x.setAttribute('data-on', '0'); });
      unbindJumpKeys();
      unbindSpeak();
      state = { font: 1, contrast: '', align: '', profile: '', colors: {}, toggles: {} };
      hideAlts();
      apply();
      try { localStorage.removeItem(KEY); } catch (e) {}
    });

    /* ── Naming third party controls we do not own ───────────────────────────
       The reviews widget renders a sort dropdown with no label at all, which a screen
       reader announces as "combo box" and nothing else. We cannot edit that app's code,
       but we can name its control in our own page. Anything already labelled is left
       alone, so if the app fixes it this quietly stops doing anything. */
    function nameOrphanControls() {
      var controls = document.querySelectorAll('select:not([aria-label]):not([aria-labelledby]):not([id])');
      for (var i = 0; i < controls.length; i++) {
        var c = controls[i];
        if (root.contains(c)) continue;
        var opts = c.options && c.options.length ? c.options[0].textContent.trim() : '';
        c.setAttribute('aria-label', opts ? 'בחירה: ' + opts.slice(0, 40) : 'בחירה');
      }
      var btns = document.querySelectorAll('button:not([aria-label]):not([title])');
      for (var j = 0; j < btns.length; j++) {
        var b = btns[j];
        if (root.contains(b)) continue;
        if ((b.textContent || '').trim()) continue;
        if (b.querySelector('img[alt]:not([alt=""])')) continue;
        b.setAttribute('aria-label', 'כפתור');
      }
    }
    /* ── Generic link text, WCAG 2.4.4 ───────────────────────────────────────
       On a shop's collection grid every card says "להוספה לסל". A screen reader user
       tabbing the page hears "להוספה לסל" eight times and cannot tell which product any of
       them belongs to. The link text stays exactly as it is on screen, and an aria-label
       adds the product name for anyone listening: "להוספה לסל, STARTER".
       The name is taken from the nearest heading or card title above the control, which
       is where a shop always puts it. */
    var GENERIC = /^(להוספה לסל|הוסיפי לעגלה|הוספה לעגלה|קרא עוד|קראו עוד|קרא\/י עוד|למידע נוסף|המשך קריאה|לחץ כאן|לחצי כאן|עוד\.\.\.|לפרטים|צפייה במוצר|צפה במוצר|לרכישה|הזמיני עכשיו|קני עכשיו|בחר|בחרי|עוד)$/;

    function nameFromContext(el) {
      var node = el;
      for (var up = 0; up < 6 && node; up++) {
        node = node.parentElement;
        if (!node) break;
        var t = node.querySelector('h1, h2, h3, h4, .rh-card__title, .product-card__title, .ola-card__title, [class*="title" i]');
        if (t) {
          var text = (t.textContent || '').replace(/\s+/g, ' ').trim();
          if (text && text.length < 80) return text;
        }
      }
      return '';
    }

    function fixGenericNames() {
      var items = document.querySelectorAll('a[href], button');
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        if (root.contains(el)) continue;
        if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) continue;
        var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label || !GENERIC.test(label)) continue;
        var name = nameFromContext(el);
        if (name) el.setAttribute('aria-label', label + ', ' + name);
      }
    }

    /* A link that opens a new tab has to say so, or the back button appears to break. */
    function announceNewTab() {
      var out = document.querySelectorAll('a[target="_blank"]:not([data-a11y-newtab])');
      for (var i = 0; i < out.length; i++) {
        var a = out[i];
        if (root.contains(a)) continue;
        a.setAttribute('data-a11y-newtab', '1');
        var current = a.getAttribute('aria-label') || (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (current) a.setAttribute('aria-label', current + ', נפתח בכרטיסייה חדשה');
      }
    }

    /* ── Reaching inside a shadow root ───────────────────────────────────────
       The reviews app renders itself in a shadow DOM, which is a sealed box: our
       stylesheet does not cross into it and document.querySelectorAll does not see it.
       An audit tool does see it, and so does a screen reader, so three real failures
       lived there where nothing we wrote could touch them: a sort dropdown with no name,
       body text at 4.2:1 and a badge at 3.25:1.
       A stylesheet can be appended INTO a shadow root, and its elements can be queried
       from its own root. Both are done here, once per root, marked so a re-render does
       not stack copies. */
    var SHADOW_CSS =
      '.text-gray-500,.text-gray-400,.text-gray-600{color:#5a6169 !important;opacity:1 !important}' +
      '[class*="text-[#3b82f6]"],[class*="text-blue"]{color:#1d4ed8 !important}' +
      '[class*="bg-[#e9f2ff]"]{color:#1a4f9c !important}' +
      'a,button{text-underline-offset:3px}';

    function shadowRoots() {
      var found = [];
      function walk(node) {
        var all = node.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          var sr = all[i].shadowRoot;
          if (!sr) continue;
          found.push(sr);
          walk(sr);
        }
      }
      try { walk(document); } catch (e) {}
      return found;
    }

    function repairShadow() {
      var roots = shadowRoots();
      for (var i = 0; i < roots.length; i++) {
        var sr = roots[i];
        if (!sr.querySelector('[data-ola-a11y-style]')) {
          var st = document.createElement('style');
          st.setAttribute('data-ola-a11y-style', '1');
          st.textContent = SHADOW_CSS;
          try { sr.appendChild(st); } catch (e) {}
        }
        var sels = sr.querySelectorAll('select:not([aria-label]):not([aria-labelledby])');
        for (var j = 0; j < sels.length; j++) {
          var c = sels[j];
          var first = c.options && c.options.length ? (c.options[0].textContent || '').trim() : '';
          c.setAttribute('aria-label', first ? 'מיון: ' + first.slice(0, 40) : 'בחירה');
        }
        var btns = sr.querySelectorAll('button:not([aria-label]):not([title])');
        for (var k = 0; k < btns.length; k++) {
          if (!(btns[k].textContent || '').trim()) btns[k].setAttribute('aria-label', 'כפתור');
        }
      }
    }

    /* A strip that scrolls but cannot be reached by keyboard. A shop is full of these:
       product carousels, image rails, the gallery of customer photos. A mouse can drag
       them and a finger can swipe them, and someone using only a keyboard cannot see what
       is inside at all. Giving the container a tab stop and a name is the whole fix, and
       the browser's arrow keys then scroll it. Anything already focusable is left alone. */
    function reachScrollers() {
      var els = document.body.querySelectorAll('div, ul, section, nav');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (root.contains(el)) continue;
        if (el.hasAttribute('tabindex') || el.getAttribute('data-a11y-scroller')) continue;
        var cs = window.getComputedStyle(el);
        var scrollsX = (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 4;
        var scrollsY = (cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 4;
        if (!scrollsX && !scrollsY) continue;
        // A region holding its own focusable children is already reachable through them.
        if (el.querySelector('a[href], button, input, select, textarea')) continue;
        el.setAttribute('data-a11y-scroller', '1');
        el.setAttribute('tabindex', '0');
        if (!el.getAttribute('role')) el.setAttribute('role', 'region');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'אזור נגלל');
      }
    }

    /* An image with no alt attribute at all is announced by its file name, which on a
       marketing popup is a line of random characters. Ours all have one; a third party
       widget's may not, and an empty alt is the correct answer for a decorative image. */
    function altlessImages() {
      var imgs = document.querySelectorAll('img:not([alt])');
      for (var i = 0; i < imgs.length; i++) {
        if (root.contains(imgs[i])) continue;
        imgs[i].setAttribute('alt', '');
      }
    }

    function repairNames() {
      altlessImages();
      nameOrphanControls();
      fixGenericNames();
      announceNewTab();
      repairShadow();
      reachScrollers();
    }

    repairNames();
    /* Third party widgets render late, and grids re-render on filter and on quick add. */
    [1500, 4000, 8000].forEach(function (ms) { setTimeout(repairNames, ms); });
    if (window.MutationObserver) {
      var repairPending = null;
      new MutationObserver(function () {
        if (repairPending || selfWriting) return;
        repairPending = setTimeout(function () { repairPending = null; repairNames(); }, 600);
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* ── The skip link, first thing in the document ─────────────────────────── */
    (function skipLinks() {
      /* Four, which is the set Israeli sites are expected to offer: the top of the page,
         the content, the bottom, and the site map. One link is the minimum; four is what
         actually saves a keyboard user from tabbing through a whole shop to reach the
         footer. Each target is given an id and a tabindex only if it does not have one,
         so nothing already working is disturbed. */
      var wrap = document.createElement('nav');
      wrap.className = 'ola-a11y__skips';
      wrap.setAttribute('aria-label', 'קישורי דילוג');

      var spots = [
        { sel: 'header, .rh-header, #header', id: 'OlaTop', label: 'לראש הדף' },
        { sel: 'main, #MainContent, [role="main"]', id: 'OlaMainContent', label: 'לתוכן הדף' },
        { sel: 'footer, .rh-footer, #footer', id: 'OlaFooter', label: 'לתחתית הדף' }
      ];

      spots.forEach(function (spot) {
        var target = document.querySelector(spot.sel);
        if (!target) return;
        if (!target.id) target.id = spot.id;
        var a = document.createElement('a');
        a.className = 'ola-a11y__skip';
        a.href = '#' + target.id;
        a.textContent = spot.label;
        a.addEventListener('click', function () {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          setTimeout(function () { try { target.focus(); } catch (e) {} }, 0);
        });
        wrap.appendChild(a);
      });

      var map = document.createElement('a');
      map.className = 'ola-a11y__skip';
      map.href = '/pages/accessibility';
      map.textContent = 'להצהרת הנגישות';
      wrap.appendChild(map);

      /* Out of the flow from the moment it exists, and added only once the page (and this
         file's stylesheet, which now loads without blocking) has loaded. Inserted earlier
         and unstyled, this row of links sat in the flow above the header for a few frames
         and pushed the whole page down and back: PageSpeed measured a layout shift of ~1
         (speed pass, 25.10.2026). The links are for keyboard users, who reach them after load. */
      wrap.style.position = 'absolute';
      wrap.style.top = '0';
      wrap.style.right = '0';
      var placeSkips = function () { document.body.insertBefore(wrap, document.body.firstChild); };
      if (document.readyState === 'complete') placeSkips();
      else window.addEventListener('load', placeSkips, { once: true });
    })();

    /* ── Staying out of the way of whatever else lives in that corner ─────────
       The shop runs a WhatsApp bubble in the bottom left, injected by an app whose
       position is not ours to control and can change when the app updates. A hardcoded
       offset covered it on the first try. So the button measures instead of assuming: it
       looks for any other fixed element sitting in the bottom left corner and parks itself
       a clear gap above the tallest one. Third party widgets arrive late, so this runs
       again after they have had time to load, and on resize, where a phone in landscape
       puts everything somewhere new. */
    function avoidCollisions() {
      var mine = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var vw = window.innerWidth;
      var GAP = 16;
      var highestTop = vh;

      var all = document.body.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (root.contains(el) || el.contains(root)) continue;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
        var r = el.getBoundingClientRect();
        if (r.width < 24 || r.height < 24) continue;
        // Full screen overlays and drawers are not neighbours, they are curtains.
        if (r.width > vw * 0.6 || r.height > vh * 0.6) continue;
        // Bottom left corner only: the advisor lives on the right and is not in the way.
        if (r.left > vw * 0.4) continue;
        if (r.bottom < vh - 240) continue;
        if (r.top < highestTop) highestTop = r.top;
      }

      if (highestTop < vh) {
        /* Corrected against where the BUTTON actually ends, not where the container's box
           says it does. Computing the offset from the container alone left a 4px gap
           instead of 16: the container is taller than the button it holds. Measuring the
           button and adjusting the current offset by the difference is self correcting,
           whatever the box turns out to be. */
        var btn = opener.getBoundingClientRect();
        var current = parseFloat(window.getComputedStyle(root).bottom) || 0;
        var wanted = current + (btn.bottom - (highestTop - GAP));
        root.style.bottom = Math.round(Math.max(18, Math.min(wanted, vh * 0.5))) + 'px';
      } else {
        root.style.removeProperty('bottom');
      }
      void mine;
    }

    load();
    apply();

    avoidCollisions();
    /* Apps inject their bubble whenever their script finishes, which is not a moment we
       can know, so the measurement is repeated a few times over the first few seconds
       rather than raced against them. */
    [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(avoidCollisions, ms); });
    window.addEventListener('resize', function () {
      clearTimeout(avoidCollisions._t);
      avoidCollisions._t = setTimeout(avoidCollisions, 200);
    });
  })();
